/**
 * Renders a numbered list item by wrapping text in nested <OL> tags. Very similar approach to existing renderList
 * function, except that we are using OL instead of UL and adding a start attribute.
 *
 * More context:
 *
 * This function is called on each list item separately, so a list like:
 * 1. one
 * 2. two
 *    1. subone
 *    2. subtwo
 * 3. three
 *
 * would generate 5 calls to renderNumberedList, and the overall list would be stored as HTML on the clipboard like:
 *
 * <ol start=1><li> one </li></ol>
 * <ol start=2><li> two </li></ol>
 * <ol><ol start=1><li> subone </li></ol></ol>
 * <ol><ol start=2><li> subtwo </li></ol></ol>
 * <ol start=3><li> three </li></ol>
 *
 * The start attribute indicates what is the relative index of the item in its grouping. It is necessary
 * since we are creating a separate ordered list for each item/notepart in the list.
 *
 * When an external editor would read this HTML from the clipboard, it would convert it into proper HTML (one root ordered list
 * with a bunch of nested child ordered lists, instead of a separate ordered list for each list item) before rendering to user.
 */
export function renderNumberedList(
  data: string,
  indentation: number,
  calculatedListIndex: number | null | undefined
): string {
  const start = calculatedListIndex != null && calculatedListIndex >= 0 ? calculatedListIndex + 1 : 1;
  const outerOpens = '<OL>'.repeat(indentation - 1);
  const outerCloses = '</OL>'.repeat(indentation - 1);
  return `${outerOpens}<OL start='${start}'><LI style='margin:0'>${data}</LI></OL>${outerCloses}`;
}
